import React from 'react';

const steps = [
  {
    number: '01',
    title: 'Scan',
    description: 'Customer scans a QR code on your product packaging or taps an NFC tag. No app needed — it opens instantly in their browser.',
  },
  {
    number: '02',
    title: 'Register',
    description: 'They register their product in seconds. You capture real customer data and activate their warranty automatically.',
  },
  {
    number: '03',
    title: 'Experience',
    description: 'Customers access setup guides, AI support, spares ordering, and more. You gain insights, reduce support costs, and drive aftermarket revenue.',
  },
];

export const HowItWorks: React.FC = () => {
  return (
    <div className="mx-auto max-w-7xl px-6 py-24 sm:py-32 lg:px-8">
      <div className="mx-auto max-w-2xl text-center mb-16">
        <h2 className="text-base/7 font-semibold" style={{ color: '#00D084' }}>How it works</h2>
        <p className="mt-2 text-4xl font-semibold tracking-tight sm:text-5xl" style={{ color: '#241E61' }}>
          Three steps to knowing every owner
        </p>
      </div>
      <div className="mx-auto grid max-w-2xl grid-cols-1 gap-12 lg:max-w-none lg:grid-cols-3">
        {steps.map((step, index) => (
          <div key={step.number} className="relative">
            {index < steps.length - 1 && (
              <div className="hidden lg:block absolute top-8 left-full w-full h-px bg-gray-200" style={{ width: 'calc(100% - 2rem)', left: 'calc(50% + 1rem)' }} />
            )}
            <div className="flex flex-col items-center text-center">
              <div
                className="flex h-16 w-16 items-center justify-center rounded-full text-xl font-bold text-white"
                style={{ backgroundColor: '#241E61' }}
              >
                {step.number}
              </div>
              <h3 className="mt-6 text-xl font-semibold" style={{ color: '#241E61' }}>
                {step.title}
              </h3>
              <p className="mt-3 text-base text-gray-600">
                {step.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
